class StudiesFilter {
	private categorySelect: HTMLSelectElement;
	private tagSelect: HTMLSelectElement;

	public constructor() {
		this.categorySelect = document.querySelector('#category-select');
		this.tagSelect = document.querySelector('#tag-select');

		this.categorySelect?.addEventListener('input', StudiesFilter.filter);
		this.tagSelect?.addEventListener('input', StudiesFilter.filter);
	}

	private static filter(event: Event): void {
		window.location.href = (event.target as HTMLSelectElement).value;
	}
}

new StudiesFilter();
